<template>
  <div>
    <div class="bd25 flex-col">
      <div class="box">
        <div class="section10 flex-row">
          <img class="pic4" referrerpolicy="no-referrer" src="../assets/imgs/gukedabei.png" />
        </div>
        <div class="section11 flex-row justify-between">
          <div class="abc">
            <span class="txt12">联系方式</span>
            <span>联系人：宁老师&nbsp;<br />手&nbsp;&nbsp;&nbsp;机：13811311065&nbsp;&nbsp;010-62576881</span>
            <span>
              邮&nbsp;&nbsp;&nbsp;箱：ieinfo&#64;ucas.ac.cn<br />地&nbsp;&nbsp;&nbsp;址：北京市海淀区中关村东路80号（100190）
            </span>
            <a href="https://beian.miit.gov.cn/" target="_blank" style="color: #ffffff;">京ICP备2025113568号</a>
          </div>
          <div class="main15 flex-col justify-between">
            <div class="wrap13 flex-col">
              <img class="img12" referrerpolicy="no-referrer" src="../assets/imgs/erweima.png" />
            </div>
            <span class="paragraph5">国科大现代产业学院<br />学院官方微信公众号</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>
<style scoped lang="less">
.box {
  padding: 0 40px;
  width: 1200px;
  margin: 0 auto;
}
.bd25 {
  height: 300px;
  min-width: 1200px;
  overflow: hidden;
  background: url("../assets/imgs/banner2.png");
  background-size: 100% 100%;
}

.section10 {
  width: 57%;
  height: 63px;
  margin-top: 40px;
}

.pic4 {
  width: 252px;
  height: 63px;
}

.section11 {
  height: 197px;
}

.main14 {
  width: 314px;
  height: 169px;
  margin-top: 28px;
}

.txt12 {
  width: 96px;
  height: 33px;
  display: block;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 24px;
  font-family: PingFangSC-Medium;
  white-space: nowrap;
  line-height: 33px;
  text-align: left;
}

.paragraph4 {
  width: 314px;
  float: left;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
  line-height: 30px;
  text-align: left;
  margin-top: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.main15 {
  width: 132px;
  height: 187px;
  position: relative;
  top: -42px;
}

.wrap13 {
  height: 132px;
  border-radius: 8px;
  background-color: rgba(255, 255, 255, 1);
  width: 132px;
}

.img12 {
  width: 122px;
  height: 122px;
  margin: 5px 0 0 5px;
}

.paragraph5 {
  width: 126px;
  height: 44px;
  display: block;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
  line-height: 22px;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 11px 0 0 3px;
}

.img13 {
  position: absolute;
  left: 0;
  top: 0;
  height: 376px;
}
.abc {
  margin-top: 40px;
  .txt12 {
    margin-bottom: 15px;
    font-size: 24px;
    display: block;
    font-weight: 500;
  }
  span {
    margin-right: 80px;
    font-size: 14px;
    line-height: 30px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    display: inline-block;
  }
}
</style>